import { render, staticRenderFns } from "./permissionManageByCourses.vue?vue&type=template&id=524d9c8a&"
import script from "./permissionManageByCourses.vue?vue&type=script&lang=js&"
export * from "./permissionManageByCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports